import BaseService from '@/services/BaseService'

class BancoService extends BaseService {
    constructor(){
        super('/v1/bancos')
    }
}

export default new BancoService